import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { CustomerModel } from "../../models/small-pack/customer.model";
import { MasterListService } from "../../services/master-list.service";
import { Subscription } from "rxjs";
import { HelpService } from "../../services/help.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { CustomerShipmentModel } from "../../models/master-list/customer-shipment-exceptions.model";

@Component({
    selector: 'app-customer-select',
    templateUrl: './customer-select.component.html',
    styleUrls: ['./customer-select.component.scss'],
    standalone: false
})
export class CustomerSelectComponent implements OnInit, OnDestroy {

  @Input() customerControl!: FormControl;
  @Input() optionAll: boolean = true;
  @Input() multiSelect: boolean = true;
  @Input() matLabel: string = 'Customers';
  @Input() screen: string;
  @Input() isDisabled: boolean = false;

  searchCriteria: string = '';
  customers: CustomerModel[] | CustomerShipmentModel[];
  spinnerLoading: boolean = false;

  private customersSubs: Subscription;
  private customersShipmentExceptionSubs: Subscription;

  constructor(
    private readonly masterListService: MasterListService,
    private readonly helperService: HelpService
  ) { }

  ngOnInit(): void {
    this.customerControl.disable();
    this.getCustomersBasedOnScreen();
  }

  ngOnDestroy(): void {
    if (this.customersSubs) {
      this.customersSubs.unsubscribe();
    }
    if (this.customersShipmentExceptionSubs) {
      this.customersShipmentExceptionSubs.unsubscribe();
    }
  }

  toggleAllServices(e: MatCheckboxChange): void {
    this.toggleAll(e.checked);
  }

  private toggleAll(selectAll: boolean): void {
    const data = [...(this.customers?.map(t => t.customerId || t.CustomerID) ?? [])];

    if (selectAll) {
      this.customerControl.setValue(data);
    } else {
      this.customerControl.setValue(null);
    }
  }

  private getCustomersBasedOnScreen(): void {
     switch (this.screen) {
      case 'audit-validation-dashboard':
        this.getCustomerWithShipmentExceptions();
        break;
        case 'brokerage-validation-dashboard':
        this.getCustomerWithShipmentExceptions(2);
        break;
      default:
        this.getAllCustomers();
        break;
     }
  }

  private getCustomerWithShipmentExceptions(customerTypeId: number = 0): void {
    this.spinnerLoading = true;
    this.customersShipmentExceptionSubs = this.masterListService.getCustomerWithShipmentExceptions(customerTypeId).subscribe({
      next: (customers) => {
        this.searchCriteria = 'customerName';
        this.customers = customers?.data
          .toSorted((a, b) =>
            a.customerName.localeCompare(b.customerName)
          );
        this.spinnerLoading = false;
        this.customerControl.enable();
      },
      error: () => {
        this.helperService.showMessageNotification('Error! Please try again.', 'danger');
        this.spinnerLoading = false;
      }
    });
  }

  private getAllCustomers(): void {
    this.spinnerLoading = true;
    this.customersSubs = this.masterListService.getAllCustomers().subscribe({
      next: (customers: CustomerModel[]) => {
        this.searchCriteria = 'CustomerName';
        this.customers = customers?.filter(customer => customer.IsActive === 1);
        this.spinnerLoading = false;
        this.customerControl.enable();
      },
      error: () => {
        this.helperService.showMessageNotification('Error! Please try again.', 'danger');
        this.spinnerLoading = false;
      }
    });
  }

}
